<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="120px" class="EL-Form">
                <el-col :lg="6" :xl="6">
                    <el-form-item label="物料类型编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.mtCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="6" :xl="6">
                    <el-form-item label="标签属性编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.labelCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="物料类型标签">
                <el-button v-authority="'BACK_MENU9_M3_B1'" class="btn-t-edit" @click="openAdd()">新增</el-button>
                <el-button v-authority="'BACK_MENU9_M3_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="lableId" label="序号ID" /> -->
                <el-table-column prop="mtCode" label="物料类型编号" />
                <el-table-column prop="mtName" label="物料类型名称" />
                <el-table-column prop="labelCode" label="标签属性编号" />
                <el-table-column prop="labelName" label="标签属性名称" />
                <el-table-column prop="defaultFlag" label="默认状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.defaultFlag == true">明码</span>
                        <span v-if="scope.row.defaultFlag == false">暗码</span>
                    </template>
                </el-table-column>
                <el-table-column prop="updateTime" label="更新时间" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU9_M3_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="(add_or_edit = false),(editBoxShow = true), update(scope.row)" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU9_M3_B3'" type="danger" @click="deleteRow(scope.row.lableId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="500px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-width="130px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-form-item label="物料类型编号：" prop="mtCode">
                        <el-select v-model="mainObj.mtCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in materialTypeList" :key="item.mtId" :label="item.mtCode + '-' + item.mtName" :value="item.mtCode">{{item.mtCode}}-{{item.mtName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="标签属性编号：" prop="labelCode">
                        <el-select v-model="mainObj.labelCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in labelAttrList" :key="item.labelId" :label="item.labelCode + '-' + item.labelName" :value="item.labelCode">{{item.labelCode}}-{{item.labelName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="默认状态：" prop="defaultFlag">
                        <!-- <el-radio-group v-model="mainObj.defaultFlag">
                            <el-radio label="true">明码</el-radio>
                            <el-radio label="false">暗码</el-radio>
                        </el-radio-group> -->
                        <el-radio v-model="radio" label="true">明码</el-radio>
                        <el-radio v-model="radio" label="false">暗码</el-radio>
                    </el-form-item>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="radio = 'true',editBoxShow=false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "labelMat",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    mtCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    labelCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    radio: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {
                    createTime: "",
                    defaultFlag: "",
                    labelCode: "",
                    lableId: "",
                    mtCode: "",
                    updateTime: "",
                },
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    mtCode: "",
                    labelCode: "",
                },
                mainData: [],
                radio: "true",

                labelAttrList: [], //标签属性
                materialTypeList: [], //物料类型

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            update(row) {
                var defaultFlag = row.defaultFlag ? "true" : "false";
                this.radio = defaultFlag;
                this.mainObj = {
                    createTime: row.createTime,
                    defaultFlag: defaultFlag,
                    labelCode: row.labelCode,
                    lableId: row.lableId,
                    mtCode: row.mtCode,
                    updateTime: row.updateTime
                }
            },
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/labelMat/getLabelMatAll",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            openAdd() {
                this.add_or_edit = true;
                this.editBoxShow = true;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                if (this.submitForm("mainObj")) {
                    this.mainObj.defaultFlag = this.radio
                    this.$http
                        .request({
                            url: "/api/labelMat/insertLabelMat",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "labelMat：物料类型标签新增成功";
                                this.editBoxShow = false;

                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "labelMat：物料类型标签新增失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t ，labelCode" +
                                this.mainObj.labelCode;
                            this.systemLog();
                            this.radio = "true";
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    this.mainObj.defaultFlag = this.radio
                    this.$http
                        .request({
                            url: "/api/labelMat/updateLabelMat",
                            method: "POST",
                            showLoading: true,
                            data: this.mainObj,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "labelMat：物料类型标签编辑成功";
                                this.editBoxShow = false;
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "labelMat：物料类型标签编辑失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t ，labelCode" +
                                this.mainObj.labelCode;
                            this.systemLog();
                            this.radio = "true";
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow: function(lableId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/labelMat/deleteLabelMat",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    lableId: lableId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "labelMat：物料类型标签删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "labelMat：物料类型标签删除失败";
                                }
                                this.logContent = "lableId：" + lableId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //获取物料类型数据
            getMaterialTypeAll() {
                this.$http
                    .request({
                        url: "/api/materialType/getMaterialTypeAll",
                        method: "GET",
                        // params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.materialTypeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },

            //获取标签属性数据
            getLabelAttrAll() {
                this.$http
                    .request({
                        url: "/api/labelAttr/getLabelAttrAll",
                        method: "GET",
                        // params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.labelAttrList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },


            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    mtCode: "",
                    labelCode: "",
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    mtCode: this.pagination.mtCode,
                    labelCode: this.pagination.labelCode,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/labelMat/getLabelMatAll',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    list.forEach(function(c) {
                        if (c.defaultFlag == true) {
                            c['defaultFlag'] = '明码'
                        } else if (c.defaultFlag == false) {
                            c['defaultFlag'] = '暗码'
                        }
                    })
                    const tHeader = ['序号ID', '物料类型编号', '标签属性编号', '默认状态', '更新时间', '创建时间']
                    const filterVal = ['lableId', 'mtCode', 'labelCode', 'defaultFlag', 'updateTime', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '物料类型标签'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_label_mat：导出物料类型标签"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料类型标签",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
        },
        activated(){
            this.getMaterialTypeAll();
            this.getLabelAttrAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>